/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import type { TippyProps } from '@tippyjs/react';
import Tippy from '@tippyjs/react';
import { followCursor } from 'tippy.js';
import { useAtomValue } from 'jotai';
import { persistedAtom } from '../../../state/utils/persistedAtom';
import * as zod from 'zod';

/**
 * From "Lazy mounting" part from https://www.npmjs.com/package/@tippyjs/react
 * This is copy-paste of https://gist.github.com/atomiks/520f4b0c7b537202a23a3059d4eec908
 */
const LazyTippy = React.forwardRef((props: any, ref: any) => {
  const [mounted, setMounted] = React.useState(false);

  const lazyPlugin = {
    fn: () => ({
      onMount: () => setMounted(true),
      onHidden: () => setMounted(false),
    }),
  };

  const computedProps = { ...props };

  computedProps.plugins = [lazyPlugin, ...(props.plugins || [])];

  if (props.render) {
    computedProps.render = (...args: any[]) =>
      mounted ? props.render(...args) : '';
  } else {
    computedProps.content = mounted ? props.content : '';
  }

  return <Tippy {...computedProps} ref={ref} />;
});

export const showTooltips = persistedAtom({
  schema: zod.boolean(),
  key: 'show_tooltips',
  defaultValue: true,
  getOnInit: true,
});

const Tooltip = (props: TippyProps) => {
  const show = useAtomValue(showTooltips);
  return show ? (
    <LazyTippy theme="light-border" plugins={[followCursor]} {...props} />
  ) : (
    <>{props.children}</>
  );
};

export default Tooltip;
